var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTalkFukidashi2({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u56FE\\u5C42_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 82.35 31.89",
    style: {
      enableBackground: "new 0 0 82.35 31.89"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#603813;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: -2.05,
    y: 14.65,
    transform: "matrix(0.9415 -0.337 0.337 0.9415 -2.8686 14.762)",
    className: "st0",
    width: 86.29,
    height: 2
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 40.76,
    y: 22.41,
    transform: "matrix(0.9055 -0.4244 0.4244 0.9055 -4.426 26.9424)",
    className: "st0",
    width: 35.02,
    height: 2
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTalkFukidashi2);
export default __webpack_public_path__ + "static/media/talk-fukidashi-2.d3e8a5b8a6adf3251ae9dbed8e630f0b.svg";
export { ForwardRef as ReactComponent };